var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{attrs:{"src":_vm.src,"alt":_vm.alt,"width":_vm.width,"height":_vm.height,"loading":_vm.loading,"itemprop":_vm.itemprop}})
}
var staticRenderFns = []

export { render, staticRenderFns }